import url_ from "asset-data:assets/galleries/ua-2021-12-09/L1000970-bw_0b59b3412a__264.jpg";
export const url = url_;